module.exports = __webpack_public_path__ + "522abd9c7a8c58c32de1ac951a0d28a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_1-320.jpg
// module id = 563
// module chunks = 0